<div class="text-center ready-set-container">
	<h2 class="ready-set-header">It Matters What’s Under the Hood</h2>
	<p class="mt-4 ready-set-content">
		Monolithic, first-generation GRC tools take an abundance of
		infrastructure to <br class="d-none d-xl-block" />
		deploy, an army of developers to drive value, extended professional
		services to <br class="d-none d-xl-block" />
		upgrade, and are nearly impossible to move once installed.
	</p>
</div>
